import Heading from 'components/common/Typography/Heading';
import styled from 'styled-components';

import { deviceMaxWidth, style } from 'utils/constants/style';

interface IProps {
  isMe?: boolean;
  show?: boolean;
}

export const UserDetailsWrap = styled.div`
  padding-top: 25px;
  max-width: 860px;
  margin: 0 auto;
  width: 100%;
  /* overflow: hidden; */

  @media only screen and (max-width: 860px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const UserDetailsDescriptionWrap = styled.div`
  max-width: 550px;
  padding-top: 15px;
  margin-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media only screen and (${deviceMaxWidth.sm}) {
    width: 100%;
    margin: 0 auto;
    padding-bottom: 20px;
    box-sizing: border-box;
  }
`;

export const UserPostWrap = styled.div`
  height: auto;
  width: 550px;
  margin-top: 16px;
  margin-bottom: 16px;

  & > div {
    margin-bottom: 0;
  }

  @media only screen and (${deviceMaxWidth.sm}) {
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 0;
  }
`;

export const HeaderBlock = styled.div<IProps>`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 130%;
  color: ${style.mainBlack.black};
  max-width: 550px;
  width: 100%;

  @media only screen and (${deviceMaxWidth.sm}) {
    max-width: 550px;
    width: 100%;
    margin: 0 auto;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 130%;
    display: flex;
    align-items: center;
    letter-spacing: 0.02em;
    color: ${style.mainBlack.black};
    box-sizing: border-box;
    align-self: flex-start;
  }
`;

export const MyGarageBlock = styled.div<IProps>`
  margin-bottom: 30px;
  width: 100%;
  max-width: 550px;
  position: relative;
  /* left: ${({ isMe }) => (isMe ? '-17px' : '0px')}; */
  overflow: hidden;
  color: '${(props) => props.theme.colors.black}';
  @media only screen and (max-width: 800px) {
    /* padding-left: 16px; */
    box-sizing: border-box;
  }
`;

export const HeaderBlockGarage = styled(Heading)<IProps>`
  /* padding-left: ${({ isMe }) => (isMe ? '20px' : '0px')}; */
  font-family: ${(props) => props.theme.typography.fontFamily.primary};
  font-weight: ${(props) => props.theme.typography.fontWeight.semiBold};
  font-size: ${(props) => props.theme.typography.fontSize.f7};
  line-height: 130%;
  color: ${(props) => props.theme.colors.black};

  @media only screen and (max-width: 800px) {
    /* padding-left: ${({ isMe }) => (isMe ? '20px' : '0px')}; */
    display: flex;
    align-items: center;
    letter-spacing: 0.02em;
    color: ${(props) => props.theme.colors.black};
  }
`;

export const ContentContainerPosts = styled.div`
  position: relative;
  top: -75px;
  max-width: 860px;
  padding: 0 10px;

  @media only screen and (max-width: 860px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* width: 100%; */
  }

  @media only screen and (${deviceMaxWidth.sm}) {
    /* width: 100vw; */
    top: 0px;
  }
  margin: 0 auto;
`;

export const UnfollowPopup = styled.div`
  width: 300px;
  height: auto;
  background-color: ${style.mainWhite.white};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.07);
  position: relative;
  top: 200px;
  padding: 10px;
  z-index: 220;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  display: flex;
  flex-direction: column;
  align-items: center;
  letter-spacing: 0.02em;
  color: ${style.mainBlack.black};
  border-radius: 8px;
  @media only screen and (max-width: 600px) and (min-width: 100px) {
    right: -150px;
  }
  right: -400px;
`;

export const UnfollowPopupWrap = styled.div<IProps>`
  position: fixed;
  z-index: 210;
  width: 100%;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  background-color: rgba(275, 275, 275, 0.7);
`;

export const UnfollowButtonWrap = styled.div`
  width: 80%;
  padding-bottom: 10px;
`;

export const ImageWrap = styled.div`
  width: 50px;
  height: 50px;
  min-height: 50px;
  border-radius: 50%;
  overflow: hidden;
`;

export const CancelButton = styled.div`
  cursor: pointer;
  color: #8d8d8d;
`;

export const FollowUserName = styled.div`
  color: #1c1f29;
  font-size: 14px;
  margin: 10px 0;
`;
export const FollowFullname = styled.div`
  color: #8d8d8d;
  font-size: 12px;
`;

export const RouteDetails = styled.div`
  @media (max-width: 576px) {
    width: 100%;
  }
`;
export const RouteHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 550px;
  @media (max-width: 860px) {
    width: 550px;
    margin: auto;
  }
  @media (max-width: 576px) {
    width: 100%;
  }
  a {
    color: #1188ff;
    text-decoration: none;
    font-size: 14px;
  }
`;
export const RouteSlider = styled.div`
  ul.react-multi-carousel-track {
    .react-multi-carousel-item {
      .sliderWrapper {
        width: 100%;
      }
    }
  }
`;

export const SuggestedRoutesSliderItem = styled.div`
  padding: 0 10px;
`;
